module.exports = __webpack_public_path__ + "static/img/jiaoyu.bb47e36.png";


//////////////////
// WEBPACK FOOTER
// ./static/jiaoyu.png
// module id = GqVr
// module chunks = 1